import type { Track } from "@wb/ui/analytics/track";

export const track: Track = (eventName, properties) => {
  const amplitude = window.amplitude;

  if (!amplitude) {
    return;
  }

  amplitude.track(eventName, properties);
};
